<template>
  <v-app>
    <TheSnackbar />
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6 lg4>
            <v-form v-model="valid" @submit.prevent="submit" ref="form" lazy-validation>
              <v-card class="elevation-12">
                <v-toolbar color="white">
                  <v-toolbar-title>
                    Administration Grossratsgeschäfte
                  </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <v-text-field
                    :rules="[$rules.required]"
                    v-model="username"
                    prepend-icon="person"
                    label="Benutzername"
                    autocomplete="username"
                    autofocus
                    box
                    required
                  ></v-text-field>
                  <v-text-field
                    :rules="[$rules.required]"
                    v-model="password"
                    prepend-icon="lock"
                    label="Passwort"
                    type="password"
                    autocomplete="current-password"
                    box
                    required
                  ></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn depressed to="/">Abbrechen</v-btn>
                  <v-btn depressed :disabled="!valid" color="primary" type="submit">Anmelden</v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { login } from '@/api';

export default {
  name: 'Login',
  data() {
    return {
      valid: true,
      username: '',
      password: '',
    };
  },
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        try {
          await login(this.username, this.password);
        } catch (e) {
          const errorMessages = e.response.data.non_field_errors;
          if (e.response.status === 400 && errorMessages) {
            this.$showSnackbar({ text: errorMessages[0], color: 'red' });
          } else {
            this.$showSnackbar({ text: 'Ein unbekannter Fehler ist aufgetreten', color: 'red' });
          }
          return;
        }
        this.$showSnackbar({ text: 'Erfolgreich angemeldet', color: 'green' });
        this.$router.push(this.$route.query.to || '/');
      }
    },
  },
};
</script>
